import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import Image from "@components/imageContainer";
import {
  Wrapper,
  Header,
  MakeModel,
  RegNumber,
  Content,
  FieldValueWrapper,
  Field,
  Value,
  Divider
} from "./styles";

import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import Hyperlink from "@components/common/hyperlink";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const VehicleCard = (props: any) => {
  const {
    reg_no,
    make,
    model,
    year,
    ncb,
    variant,
    ppepd_text,
    actions,
    is_visible,
    wrapperStyles,
    fuelType,
    owner,
    phone,
    pincode,
    product
  } = props;

  const { on_click } = actions || {};

  const isNcbPresent = ncb === 0 || (ncb !== 0 && !!ncb);
  const isPpedPresent = ppepd_text && ppepd_text !== "null";
  const mmvImg = product ==="bike" ? "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-prequote/bike_insurance.svg" : "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-prequote/car_insurance.svg"

  return is_visible ? (
    <Wrapper styles={wrapperStyles}>
      <Header>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          styles={{ gap: "12px" }}
        >
          <Image
            imgSrc={mmvImg}
            alt="vehicle-dummy"
            width={60}
            height={60}
          />
          <Flex flexDirection="column" styles={{ gap: "4px" }}>
            <Flex flexDirection="row" justifyContent="space-between">
              <MakeModel>
                {make} {model}
              </MakeModel>
              <Flex
                style={{
                  gap: "4px",
                  width: "max-content",
                  alignItems: "center"
                }}
                onClick={() => {
                  if (on_click?.length > 0) {
                    on_click?.forEach((eachFunc: any) => {
                      typeof eachFunc.funCall === "function" &&
                        eachFunc.funCall(eachFunc.args);
                    });
                  }
                }}
              >
                <ImageContainer
                  imgSrc={resolvePath("/images/edit_icon.svg")}
                  height={16}
                  width={16}
                  alt={"edit"}
                />
                <Hyperlink
                  type="PRIMARY"
                  text="Edit"
                  clickHandler={() => {
                    if (on_click?.length > 0) {
                      on_click?.forEach((eachFunc: any) => {
                        typeof eachFunc.funCall === "function" &&
                          eachFunc.funCall(eachFunc.args);
                      });
                    }
                  }}
                />
              </Flex>
            </Flex>
            <RegNumber>{reg_no}</RegNumber>
          </Flex>
        </Flex>
      </Header>

      <Content>
        <Flex flexDirection="column" styles={{ gap: "12px" }}>
          {variant && (
            <FieldValueWrapper>
              <Field>Variant</Field>
              <Value>{variant}</Value>
            </FieldValueWrapper>
          )}
          {fuelType && (
            <FieldValueWrapper>
              <Field>Fuel type</Field>
              <Value>{fuelType}</Value>
            </FieldValueWrapper>
          )}
          {year && (
            <FieldValueWrapper>
              <Field>Registration year</Field>
              <Value>{year}</Value>
            </FieldValueWrapper>
          )}
        </Flex>

        {(isNcbPresent || isPpedPresent || owner) && <Divider />}

        {isNcbPresent && (
          <FieldValueWrapper>
            <Field>No Claim Bonus (NCB)</Field>
            <Value>{ncb}%</Value>
          </FieldValueWrapper>
        )}

        {isPpedPresent && (
          <FieldValueWrapper>
            <Field>Policy expiry date</Field>
            <Value>{ppepd_text}</Value>
          </FieldValueWrapper>
        )}
        {owner && (
          <FieldValueWrapper>
            <Field>Owner name</Field>
            <Value>
              {owner
                .split(" ")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ")}
            </Value>
          </FieldValueWrapper>
        )}
        {phone && (
          <FieldValueWrapper>
            <Field>Phone number</Field>
            <Value>{phone}</Value>
          </FieldValueWrapper>
        )}
        {pincode && (
          <FieldValueWrapper>
            <Field>Pin code</Field>
            <Value>{pincode}</Value>
          </FieldValueWrapper>
        )}
      </Content>
    </Wrapper>
  ) : null;
};

export default connect(mapStateToProps)(VehicleCard);
